module.exports = __webpack_public_path__ + "img/agent02.7f14dda1.png";